import React, { FC, useState } from 'react';

interface ImageProps {
  src: string;
  alt: string;
  disabled?: boolean;
  onClick?: () => void;
  width?: string;
  height?: string;
  style?: React.CSSProperties; // Allowing the provision of custom styles
  onError?: React.EventHandler<React.SyntheticEvent<HTMLImageElement, Event>>; // Correct event type
}

const Image: FC<ImageProps> = ({
  src,
  alt,
  disabled = false,
  onClick,
  width,
  height,
  style,
  onError,
}) => {
  // Se recuerda la URL que falló, no la URL a mostrar: guardar `src` en estado
  // lo congelaba en el primer valor y, al reusarse el mismo nodo (p. ej. el logo
  // del CC seleccionado en el filtro), seguía mostrando la imagen anterior hasta
  // refrescar la página (EC-3723).
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  const handleError = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    setFailedSrc(src); // Oculta solo esta URL; si `src` cambia se reintenta
    // El prop estaba declarado pero nunca se llamaba, así que quien envolviera al
    // atom no podía enterarse del fallo para mostrar un respaldo (EC-3734).
    onError?.(event);
  };

  return (
    src && failedSrc !== src ? (
      <img
        src={src}
        alt={alt}
        onClick={onClick}
        style={{
          pointerEvents: disabled ? "none" : "auto",
          width,
          height,
          cursor: onClick ? "pointer" : "default", // Restoring cursor pointer if onClick is provided
          ...style, // Adding custom styles if any
        }}
        onError={handleError} // Llamar a handleError cuando ocurre un error en la carga de la imagen
      />
    ) : null // Si no hay una URL de imagen válida, no renderiza nada
  );
};

export default Image;
